import { normalizeUrl } from "helpers/url";

export const splitUrlFromHost = (url) => {
  if (!url) {
    return { host: "", path: "/" };
  }
  const urlParts = url.split("/");
  const host = urlParts[0] + "//" + urlParts[2];
  const path = `/${urlParts.slice(3).join("/")}`;
  return { host, path };
};

export const getQueryParameterFromUrl = (name, url) => {
  name = name.replace(/[\\]]/, "\\$&");
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const addParameterToURL = (param, url) => {
  if (typeof url !== "string") return "";
  if (url.includes(param)) return url;
  const isMapView = param === "view_type=map" || url.includes("bottom_left");
  return isMapView
    ? `${url}${url.split("?")[1] ? "&" : "?"}view_type=map`
    : `${url}/${url.split("?")[1] ? "&" : "?"}view_type=map`;
};

export const getUrlToRedirect = (path, viewType) => {
  return normalizeUrl(path, false);
};

export const removeQueryParameterFromUrl = (key, sourceURL) => {
  let rtn = sourceURL.split("?")[0];
  let param;
  let paramsArr = [];
  const queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
    paramsArr = queryString.split("&");
    for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
      param = paramsArr[i].split("=")[0];
      if (param === key) {
        paramsArr.splice(i, 1);
      }
    }
    rtn = paramsArr.length > 0 ? `${rtn}?${paramsArr.join("&")}` : `${rtn}`;
  }
  return rtn;
};

export const detectQueryString = (url) => {
  const pattern = /\?+/g;
  return pattern.test(url);
};

export const addAnchorToUrl = (url, anchor) => {
  const urlParts = url.split("#");
  if (urlParts.length === 1) {
    return `${url}#${anchor}`;
  }
};

export const removeAnchorFromUrl = (url, anchor) => {
  const urlParts = url.split("#");
  return urlParts[0];
};

export const combinePageAndResponsePath = (currnetPagePath, responsePath) => {
  const combinedPath = {
    basePath: `${currnetPagePath}${responsePath?.basePath}`,
    pagedPath: `${currnetPagePath}${responsePath?.pagedPath}`,
    queryParams: responsePath?.queryParams,
    path: `${currnetPagePath}${responsePath?.path}`,
    canonicalPath: `${currnetPagePath}${responsePath?.canonicalPath}`,
    urlForFirstPage: `${currnetPagePath}${responsePath?.urlForFirstPage}`,
  };
  return combinedPath;
};
